// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 53 ? "webfontloader" : chunkId) + "." + {"53":"8ca06896","840":"0929979c","908":"22185770","924":"e43efaff"}[chunkId] + ".js";
};